// Mock data for Book Cricket Game

export const mockMatchHistory = [
  {
    id: "1",
    date: "2025-07-10T14:30:00Z",
    mode: "pvp",
    player1: { name: "Virat", score: 45 },
    player2: { name: "Rohit", score: 38 },
    winner: "Virat",
    balls: [4, 5, 2, 6, 3, 7, 1, 9, 4, 2, 0]
  },
  {
    id: "2",
    date: "2025-07-09T10:15:00Z",
    mode: "pvc",
    player1: { name: "Player", score: 32 },
    player2: { name: "Computer", score: 41 },
    winner: "Computer",
    balls: [3, 6, 4, 1, 2, 5, 7, 4, 0]
  },
  {
    id: "3",
    date: "2025-07-08T18:45:00Z",
    mode: "pvp",
    player1: { name: "Sachin", score: 67 },
    player2: { name: "Dhoni", score: 67 },
    winner: "Tie",
    balls: [6, 4, 4, 6, 5, 3, 7, 9, 6, 4, 5, 8]
  }
];

export const generateRandomPage = () => {
  // Generate a random page number between 1 and 500
  return Math.floor(Math.random() * 500) + 1;
};

export const getLastDigit = (num) => {
  return num % 10;
};

export const isOut = (digit) => {
  return digit === 0 || digit === 8;
};

export const soundEffects = {
  hit: '/sounds/hit.mp3',
  out: '/sounds/out.mp3',
  cheer: '/sounds/cheer.mp3',
  flip: '/sounds/flip.mp3'
};
